<template>
  <v-card color="transparent" flat v-if="getWizardStep === wizardStep.DAMAGE">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" class="d-flex align-center justify-center">
          <svg :width="330" :height="360" viewBox="0 0 440 395" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.6207 1.00009C33.6715 1.00009 31.8002 1.30112 29.8508 1.75262L13.2423 6.04208L9.57769 5.44003C6.22497 4.83801 3.10609 7.24615 2.95005 10.5572L1.23465 40.4329C1.07871 42.54 2.95005 44.1956 5.05519 44.0449C8.32996 43.7439 11.6828 43.3676 15.2694 43.2924C35.4633 42.6904 52.6174 58.0418 52.3835 77.5316C52.2276 96.1186 36.5561 111.17 17.218 111.17C12.7736 111.17 8.79703 111.094 4.74266 110.793C2.71547 110.643 1.00006 112.223 1.00006 114.18L1.00006 279.964C1.00006 282.071 2.87136 283.652 5.05459 283.351C8.56335 282.824 12.15 282.598 16.0485 282.598C35.541 282.372 52.3053 297.498 52.4612 316.311C52.6171 335.199 36.7896 350.55 17.2957 350.55C16.282 350.55 15.1904 350.475 14.1768 350.4C11.8377 350.174 10.0443 352.281 10.5121 354.463L11.4478 358.903C11.6037 360.86 12.3055 366.88 17.2957 372.223C19.4789 374.556 21.818 376.061 23.9233 377.114C27.588 378.92 31.0188 381.253 34.0596 384.037C35.3851 385.242 36.7886 386.521 38.1141 387.725C42.9484 390.509 48.1724 387.875 53.7857 388.101C63.4541 388.402 72.8104 382.382 82.4787 384.79C83.8822 385.166 85.4417 384.64 86.2213 383.511C89.1062 379.522 90.5878 374.782 90.5878 369.89V352.582C90.5878 351.603 90.8217 350.7 91.2895 349.873C93.7845 345.959 96.3576 342.122 98.8528 338.209C108.287 323.76 115.227 307.957 119.203 291.251C119.437 290.348 119.592 289.445 119.826 288.542C122.321 277.178 123.335 266.793 123.569 258.14V227.06C123.569 195.68 115.07 164.827 98.9306 137.586L79.672 105.002L68.2103 39.1558C66.4169 28.8462 62.1286 19.0637 55.6568 10.6351C55.5788 10.5598 50.4328 1.00281 35.6188 1.00281L35.6207 1.00009Z"
              fill="white"
              stroke="#D3D2D2"
              stroke-width="1.04"
            />

            <path
              @click="setCarDamageOnSvg('leftRearDoorDamage')"
              d="M84.8583 308.796C86.2578 309.578 87.8783 309.791 89.3513 309.293C93.1077 308.014 96.1276 305.455 97.9691 302.113L101.725 295.147C109.533 280.787 113.584 264.651 113.584 248.442V228.325L87.7302 223.633C76.9027 221.643 65.7809 220.648 54.8056 220.648H16.0621C16.0621 224.273 15.9884 232.732 15.9884 241.192C15.9884 247.661 15.9884 252.851 16.0621 256.476C16.0621 259.248 17.6824 262.163 20.4814 264.437C22.6174 266.215 24.9008 267.85 27.2578 269.342C29.7621 270.906 31.6771 271.831 33.5185 272.684C35.7281 273.75 37.8642 274.745 40.4421 276.593C43.0938 278.513 45.5981 280.788 47.8077 283.347C52.2271 288.465 57.383 292.801 63.2754 296.213L63.3491 296.285H63.4227L84.8563 308.796L84.8583 308.796ZM83.5325 301.26C80.8808 298.204 79.4078 294.294 79.4078 290.242V229.462C79.4078 228.254 80.5126 227.33 81.7648 227.472L106.366 231.097C108.723 231.453 110.417 233.372 110.343 235.647L110.049 250.86C109.754 265.077 105.776 278.94 98.4109 291.237L95.6119 295.929C93.9915 298.63 91.6344 300.834 88.7618 302.256C86.9941 303.18 84.7844 302.753 83.5323 301.261L83.5325 301.26Z"
              :class="getFillColor('leftRearDoorDamage')"
            />

            <path
              @click="setCarDamageOnSvg('leftFrontDoorDamage')"
              d="M88.5039 219.563L113.584 224.119L113.363 219.705C111.888 192.011 103.257 164.813 88.4295 141.036C85.1838 135.91 80.0938 132.065 74.1186 130.428C56.9301 125.586 38.5634 124.447 20.8592 127.153L18.2774 127.58C16.9496 127.793 15.9906 128.861 15.9906 130.214L15.9906 216.573H54.7926C66.079 216.573 77.4388 217.57 88.5041 219.564L88.5039 219.563ZM107.019 219.99L83.0447 214.223C80.4629 213.582 78.6187 211.447 78.4711 208.884L75.5941 157.837H75.5203C71.6845 157.837 68.5124 154.847 68.5124 151.073V140.109C68.5124 139.184 68.7337 138.329 69.0288 137.475C69.1763 137.119 69.6189 136.977 69.9878 137.119C70.3566 137.261 70.5041 137.689 70.3566 138.045C70.0615 138.685 69.914 139.397 69.914 140.109V151.073C69.914 154.063 72.4221 156.484 75.5203 156.484H75.594C79.0611 156.484 81.8643 153.779 81.8643 150.432V139.468V139.112L82.2331 139.682C96.1752 159.901 105.175 182.826 108.495 206.889L109.97 217.497C110.265 218.992 108.716 220.345 107.02 219.989L107.019 219.99Z"
              fill="#E3E3E3"
              :class="getFillColor('leftFrontDoorDamage')"
            />
            <path
              d="M153.7 17.4586C147.228 20.9201 142.16 26.2632 139.197 32.8094C137.326 36.8731 136.39 41.3128 136.39 45.7527V126.875C136 126.95 135.766 127.025 135.61 127.101C132.569 128.004 122.511 131.089 119.002 138.765C117.676 141.549 117.91 143.656 117.988 144.108C117.988 144.409 118.222 146.215 119.002 147.118C121.731 150.353 131.477 143.506 136.39 139.743V242.989C136.39 246.225 136 249.536 135.142 252.697C134.284 255.858 133.895 259.169 133.895 262.405V339.689C133.895 344.129 134.752 348.494 136.39 352.633C142.315 367.382 151.594 381.831 167.734 384.766C183.953 387.776 201.028 388.303 217.09 388.303C230.58 388.303 244.692 387.926 258.493 386.045V392.441C258.493 393.344 258.493 394.925 263.717 395C268.863 395 268.941 393.043 268.941 389.958V384.314C283.6 380.401 292.254 366.705 297.868 352.709C299.505 348.57 300.363 344.205 300.363 339.765V262.481C300.363 259.17 299.973 255.934 299.115 252.773C298.258 249.613 297.868 246.301 297.868 243.066V139.819C302.78 143.582 312.527 150.43 315.256 147.194C316.036 146.291 316.269 144.485 316.269 144.184C316.347 143.732 316.581 141.625 315.256 138.841C311.747 131.24 301.689 128.155 298.647 127.177C298.491 127.101 298.18 127.026 297.868 126.951V45.8289C297.868 41.389 296.932 36.9491 295.061 32.8856C292.098 26.4138 287.03 20.9957 280.558 17.5347C268.005 10.9125 245.081 1.28006 217.089 1.28006C189.176 1.2048 166.252 10.8371 153.698 17.4598L153.7 17.4586ZM146.994 296.714V144.33C146.994 143.352 148.398 143.126 148.709 144.105L160.639 183.762C161.653 187.073 162.12 190.535 162.12 193.997V260.52C162.12 265.788 160.951 270.98 158.69 275.721L148.631 297.093C148.242 297.921 146.994 297.62 146.994 296.717L146.994 296.714ZM271.826 319.064C255.217 321.848 236.66 323.428 217.168 323.428C197.675 323.428 179.118 321.848 162.51 319.064C159.859 318.612 158.455 315.903 159.547 313.57L170.073 292.499C170.853 290.994 172.49 290.091 174.205 290.317C186.603 291.973 201.339 292.951 217.089 292.951C232.839 292.951 247.576 291.973 259.973 290.317C261.688 290.091 263.403 290.994 264.105 292.499L274.631 313.57C275.957 315.903 274.475 318.612 271.824 319.064H271.826ZM287.341 144.33V296.714C287.341 297.617 286.094 297.918 285.626 297.09L275.568 275.718C273.306 270.977 272.137 265.785 272.137 260.517V193.994C272.137 190.532 272.683 187.07 273.618 183.759L285.548 144.102C285.86 143.199 287.341 143.349 287.341 144.327L287.341 144.33ZM276.035 125.517C279.934 126.57 282.195 130.484 281.104 134.246L269.408 174.28C268.316 177.892 264.574 180.075 260.753 179.247C247.888 176.538 232.995 175.033 217.088 175.033C201.183 175.033 186.289 176.538 173.424 179.247C169.603 179.999 165.86 177.892 164.769 174.28L153.073 134.246C151.982 130.484 154.243 126.57 158.141 125.517C176.153 120.475 196.035 117.691 217.088 117.691C238.141 117.691 258.101 120.475 276.034 125.517H276.035Z"
              fill="white"
              stroke="#D3D2D2"
              stroke-width="1.04"
            />
            <path
              @click="setCarDamageOnSvg('leftRearFenderDamage')"
              d="M82.8348 379.596C82.8348 379.596 85.7582 370.426 84.2965 356.319L84.735 348.277C84.735 348.277 95.9904 334.452 95.5519 330.219C95.0403 325.987 82.9079 318.651 82.9079 318.651L53.6738 302.71C54.0392 302.921 58.7899 325.494 51.5543 335.933C45.2688 344.962 35.3296 351.945 24.8039 353.144L17.4951 354.343C17.4951 354.343 16.9104 368.309 27.3619 372.824C37.8133 377.338 41.5408 382.628 41.5408 382.628C41.5408 382.628 57.4732 384.039 61.4199 381.429C65.2935 378.89 82.834 379.595 82.834 379.595L82.8348 379.596Z"
              fill="#E3E3E3"
              :class="getFillColor('leftRearFenderDamage')"
            />
            <path
              @click="setCarDamageOnSvg('leftFrontFenderDamage')"
              d="M75.9231 117.304L62.3881 37.5775C62.3881 37.5775 55.6942 15.0722 49.368 12.7293C43.0418 10.3864 38.8489 9.17958 34.2151 10.3864C29.5807 11.5933 18.473 14.6462 18.473 14.6462C18.473 14.6462 9.20453 9.67648 9.20453 15.5691C9.20453 21.4616 7.73334 39.4894 7.73334 39.4894C7.73334 39.4894 56.4104 36.0102 57.0595 77.7593C57.6541 116.085 14.1339 115.089 14.1339 115.089V123.905C14.1339 123.905 48.9277 115.315 75.9239 123.905V117.304L75.9231 117.304Z"
              fill="#E3E3E3"
              :class="getFillColor('leftFrontFenderDamage')"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M379.203 10.6084C372.731 19.0366 368.443 28.7443 366.649 39.1291L355.187 104.975L335.929 137.56C319.788 164.802 311.291 195.655 311.291 227.034V258.113C311.602 266.842 312.538 277.151 315.033 288.515C315.267 289.418 315.423 290.321 315.657 291.224C319.556 307.855 326.573 323.658 336.007 338.182C338.502 342.095 341.075 345.933 343.57 349.846C344.038 350.674 344.272 351.652 344.272 352.555V369.863C344.272 374.755 345.831 379.496 348.638 383.484C349.496 384.688 350.977 385.14 352.381 384.763C362.049 382.355 371.406 388.451 381.074 388.075C386.688 387.924 391.99 390.483 396.745 387.698C398.071 386.494 399.474 385.215 400.8 384.011C403.841 381.226 407.194 378.894 410.936 377.088C412.963 376.034 415.381 374.529 417.564 372.196C422.554 366.853 423.256 360.833 423.412 358.877L424.347 354.437C424.815 352.254 422.944 350.223 420.683 350.373C419.669 350.448 418.656 350.524 417.564 350.524C398.071 350.524 382.242 335.173 382.398 316.284C382.554 297.471 399.319 282.345 418.811 282.571C422.71 282.647 426.296 282.797 429.805 283.324C431.91 283.625 433.859 282.045 433.859 279.938V114.228C433.859 112.271 432.144 110.691 430.117 110.842C426.062 111.143 422.164 111.218 417.642 111.218C398.305 111.218 382.632 96.1669 382.476 77.5798C382.32 58.0889 399.474 42.7381 419.59 43.3407C423.177 43.416 426.53 43.7922 429.804 44.0932C431.988 44.3189 433.781 42.5881 433.625 40.4812L431.909 10.6055C431.754 7.2944 428.635 4.96161 425.282 5.48834L421.617 6.09033L405.009 1.80093C403.06 1.27417 401.188 1.04843 399.239 1.04843C384.346 1.04843 379.201 10.6055 379.201 10.6055L379.203 10.6084Z"
              fill="white"
              stroke="#D3D2D2"
              stroke-width="1.04"
            />
            <path
              @click="setCarDamageOnSvg('rightFrontFenderDamage')"
              d="M358.517 117.304L372.052 37.5775C372.052 37.5775 378.746 15.0722 385.072 12.7293C391.398 10.3864 395.591 9.17958 400.225 10.3864C404.859 11.5933 415.967 14.6462 415.967 14.6462C415.967 14.6462 425.236 9.67648 425.236 15.5691C425.236 21.4616 426.707 39.4894 426.707 39.4894C426.707 39.4894 378.03 36.0102 377.381 77.7593C376.786 116.085 420.306 115.089 420.306 115.089V123.905C420.306 123.905 385.512 115.315 358.516 123.905V117.304L358.517 117.304Z"
              fill="#E3E3E3"
              :class="getFillColor('rightFrontFenderDamage')"
            />
            <path
              @click="setCarDamageOnSvg('rightRearDoorDamage')"
              d="M371.933 296.219L372.08 296.148C377.973 292.736 383.202 288.4 387.548 283.282C389.757 280.651 392.262 278.377 394.913 276.528C397.491 274.68 399.627 273.685 401.837 272.618C403.678 271.694 405.667 270.77 408.098 269.277C410.455 267.784 412.738 266.149 414.874 264.372C417.599 262.097 419.22 259.183 419.293 256.411C419.367 252.714 419.367 247.596 419.367 241.127C419.367 232.739 419.293 224.208 419.293 220.583H380.55C369.501 220.583 358.454 221.578 347.625 223.568L321.771 228.26V248.449C321.771 264.658 325.896 280.794 333.63 295.154L337.386 302.12C339.228 305.533 342.248 308.021 346.004 309.3C347.477 309.798 349.098 309.585 350.497 308.803L371.931 296.22L371.933 296.219ZM346.594 302.191C343.722 300.769 341.365 298.565 339.744 295.864L336.945 291.172C329.58 278.874 325.602 265.013 325.308 250.795L325.013 235.582C324.939 233.307 326.707 231.317 328.99 231.032L353.591 227.407C354.844 227.194 355.948 228.118 355.948 229.397V290.177C355.948 294.229 354.475 298.068 351.824 301.196C350.571 302.617 348.362 303.044 346.594 302.191L346.594 302.191Z"
              fill="#E3E3E3"
              :class="getFillColor('rightRearDoorDamage')"
            />
            <path
              @click="setCarDamageOnSvg('rightFrontDoorDamage')"
              d="M380.567 215.081H419.369V128.651C419.369 127.37 418.41 126.23 417.082 126.017L414.5 125.59C396.796 122.884 378.428 124.023 361.241 128.865C355.266 130.573 350.176 134.347 346.93 139.473C332.029 163.323 323.471 190.52 321.996 218.214L321.775 222.628L346.855 218.072C357.921 216.078 369.281 215.082 380.567 215.082L380.567 215.081ZM325.315 215.864L326.791 205.256C330.11 181.192 339.11 158.196 353.052 138.049L353.421 137.479V137.835V148.799C353.421 152.145 356.224 154.851 359.691 154.851H359.765C362.863 154.851 365.371 152.43 365.371 149.44V138.476C365.371 137.764 365.224 137.052 364.929 136.411C364.781 136.056 364.929 135.628 365.298 135.486C365.666 135.344 366.109 135.486 366.257 135.842C366.625 136.696 366.773 137.551 366.773 138.476V149.44C366.773 153.142 363.675 156.204 359.765 156.204H359.691L356.814 207.251C356.667 209.814 354.823 211.95 352.241 212.59L328.266 218.357C326.643 218.855 325.094 217.503 325.316 215.865L325.315 215.864Z"
              fill="#E3E3E3"
              :class="getFillColor('rightFrontDoorDamage')"
            />
            <path
              @click="setCarDamageOnSvg('rightRearFenderDamage')"
              d="M351.847 380.866C351.847 380.866 348.728 371.083 350.287 356.032L349.819 347.453C349.819 347.453 337.812 332.704 338.28 328.189C338.825 323.674 351.769 315.848 351.769 315.848L382.958 298.84C382.568 299.066 377.5 323.147 385.219 334.285C391.924 343.917 402.529 351.367 413.756 352.647L421.553 353.926C421.553 353.926 422.177 368.826 411.027 373.642C399.877 378.458 395.901 384.102 395.901 384.102C395.901 384.102 378.903 385.607 374.692 382.823C370.56 380.114 351.847 380.866 351.847 380.866V380.866Z"
              fill="#E3E3E3"
              :class="getFillColor('rightRearFenderDamage')"
            />
            <path
              @click="setCarDamageOnSvg('frontHoodDamage')"
              d="M150.896 123.69C150.896 123.69 212.103 101.264 281.499 123.69V42.794C281.499 42.794 269.258 11.8661 216.939 14.4997C164.619 17.1335 150.896 42.794 150.896 42.794V123.69Z"
              fill="#E3E3E3"
              :class="getFillColor('frontHoodDamage')"
            />
            <path
              @click="setCarDamageOnSvg('rearHoodDamage')"
              d="M150.942 325.089V360.91C150.942 360.91 148.992 377.013 170.434 377.013H268.757C268.757 377.013 281.934 374.455 281.934 364.296V325.089C281.934 325.089 225.405 337.882 150.941 325.089L150.942 325.089Z"
              fill="#E3E3E3"
              :class="getFillColor('rearHoodDamage')"
            />
            <path
              @click="setCarDamageOnSvg('ceilingDamage')"
              d="M167.385 279.341C167.385 279.341 209.879 295.521 264.069 281.072V185.652C264.069 185.652 214.947 172.482 167.385 185.652V279.341V279.341Z"
              fill="#E3E3E3"
              :class="getFillColor('ceilingDamage')"
            />
            <text fill="#fff" font-weight="bold" font-size="15" x="30" y="32">
              {{ getDamageIssueText('leftFrontFenderDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="40" y="175">
              {{ getDamageIssueText('leftFrontDoorDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="40" y="250">
              {{ getDamageIssueText('leftRearDoorDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="50" y="365">
              {{ getDamageIssueText('leftRearFenderDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="215" y="70">
              {{ getDamageIssueText('frontHoodDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="215" y="240">
              {{ getDamageIssueText('ceilingDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="215" y="360">
              {{ getDamageIssueText('rearHoodDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="395" y="32">
              {{ getDamageIssueText('rightFrontFenderDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="385" y="175">
              {{ getDamageIssueText('rightFrontDoorDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="385" y="250">
              {{ getDamageIssueText('rightRearDoorDamage') }}
            </text>
            <text fill="#fff" font-weight="bold" font-size="15" x="375" y="365">
              {{ getDamageIssueText('rightRearFenderDamage') }}
            </text>
          </svg>
        </v-col>
        <v-col cols="12">
          <v-simple-table dense class="transparent">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center"></th>
                  <th
                    class="pa-0 text-center issue-type"
                    style="min-width: 45px"
                    v-for="(issue, issueIndex) in issueTypes"
                    :key="`issue-${issueIndex}`"
                  >
                    {{ issue.label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(carPart, partIndex) in carPartType" :key="`part-${partIndex}`">
                  <td class="damage-part">{{ carPart.label }}</td>
                  <td
                    class="text-center pa-0"
                    v-for="(issue, issueIndex) in issueTypes"
                    :key="`part-issue-${issueIndex}`"
                  >
                    <v-btn icon small @click="setCarDamage(carPart.field, issue.id)">
                      <v-icon
                        :class="damage[carPart.field] === issue.id ? `${issue.color}--text` : 'primary--text'"
                        v-text="damage[carPart.field] === issue.id ? 'fas fa-circle' : 'far fa-circle'"
                        small
                      ></v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <div class="d-flex justify-space-around align-center my-5">
        <div v-for="(issue, issueIndex) in issueTypes" :key="`issuelegenda-${issueIndex}`" class="text-center">
          <v-icon left :class="issueIconColor(issue)" v-text="'fas fa-circle'" small></v-icon>
          {{ issue.label }}
        </div>
      </div>
      <v-row dense>
        <v-col cols="12">
          <v-subheader>Plaka</v-subheader>
          <v-text-field
            label="Plaka"
            solo
            hide-details="auto"
            flat
            dense
            class="plate rounded-lg"
            maxlength="9"
            v-model="damage.plateNumber"
            @beforeinput="checkPlate"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-subheader>Şasi No</v-subheader>
          <v-text-field
            label="Şasi No"
            solo
            hide-details="auto"
            flat
            dense
            class="rounded-lg"
            maxlength="17"
            v-model="$v.damage.chassisNumber.$model"
            :error-messages="chassisNumberErrors()"
            @beforeinput="checkChassisNumber($event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-subheader>Tramer</v-subheader>
          <v-select
            item-text="value"
            item-value="key"
            label="Tramer"
            solo
            hide-details
            flat
            dense
            class="rounded-lg"
            @change="additionalDamageCostChanged"
            v-model="damage.hasAdditionalDamageCost"
            :items="tramerOptions"
          ></v-select>
        </v-col>
        <v-col cols="12">
          <v-subheader>Tramer Tutarı</v-subheader>
          <v-text-field-money
            v-model="$v.damage.additionalDamageCost.$model"
            v-bind:label="'Tramer Tutarı'"
            v-bind:properties="{
              inputmode: 'numeric',
              solo: true,
              dense: true,
              flat: true,
              class: 'rounded-lg',
              errorMessages: additionalDamageCostErrors(),
              hideDetails: 'auto',
              disabled: damageCostIsDisabled,
            }"
            v-bind:options="{
              locale: 'tr-TR',
              precision: 0,
            }"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-col>
        <v-btn
          block
          shaped
          outlined
          color="primary"
          class="px-5 rounded-lg text-capitalize"
          v-text="'Geri'"
          @click="returnBack"
        ></v-btn>
      </v-col>
      <v-col>
        <v-btn
          block
          :loading="loading"
          shaped
          color="primary"
          class="px-5 rounded-lg text-capitalize"
          v-text="'Devam Et'"
          @click="continueProcess"
        ></v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
import wizardMixin from '@/mixins/wizardMixin';
import { wizardStep, carPartType, issueType } from '@/common/enums';
import { mapActions, mapGetters } from 'vuex';
import { SAVE_CAR_DAMAGE, CHANGE_WIZARD_STEP } from '@/store/modules/carWizard.module';
import { validationMixin } from 'vuelidate';
import damageValidationMixin from '@/mixins/validations/carWizard/damageValidationMixin';

export default {
  name: 'DamageStep',
  mixins: [validationMixin, damageValidationMixin, wizardMixin],
  data() {
    return {
      wizardStep,
      carPartType,
      issueType,
      loading: false,
      damage: {
        leftFrontFenderDamage: issueType.NONE.id,
        rightFrontFenderDamage: issueType.NONE.id,
        leftFrontDoorDamage: issueType.NONE.id,
        rightFrontDoorDamage: issueType.NONE.id,
        leftRearDoorDamage: issueType.NONE.id,
        rightRearDoorDamage: issueType.NONE.id,
        leftRearFenderDamage: issueType.NONE.id,
        rightRearFenderDamage: issueType.NONE.id,
        frontHoodDamage: issueType.NONE.id,
        rearHoodDamage: issueType.NONE.id,
        ceilingDamage: issueType.NONE.id,
        hasAdditionalDamageCost: false,
        additionalDamageCost: null,
        plateNumber: null,
        chassisNumber: null,
      },
    };
  },
  computed: {
    ...mapGetters(['getCarDamages']),
    issueTypes() {
      return Object.values(this.issueType).filter((x) => !x.onlyListing);
    },
    carPartTypes() {
      return Object.values(this.carPartType);
    },
    tramerOptions() {
      return [
        {
          key: false,
          value: 'Yok',
        },
        {
          key: true,
          value: 'Var',
        },
      ];
    },
    damageCostIsDisabled() {
      return !this.damage.hasAdditionalDamageCost;
    },
  },
  created() {
    this.$nextTick(() => {
      this.changeWizardStep(this.wizardStep.DAMAGE);
      if (this.getCarDamages) this.damage = this.getCarDamages;
    });
  },
  methods: {
    ...mapActions({
      changeWizardStep: CHANGE_WIZARD_STEP,
      saveCarDamage: SAVE_CAR_DAMAGE,
    }),
    setCarDamage(field, issue) {
      this.damage[field] = issue;
    },
    setCarDamageOnSvg(field) {
      let index = this.damage[field];
      if (index === this.issueType.REPLACED.id) index = this.issueType.NONE.id;
      else index += 1;
      this.setCarDamage(field, index);
    },
    getDamageIssueText(field) {
      return Object.values(issueType)
        .find((x) => x.id === this.damage[field])
        ?.code.toUpperCase();
    },
    getFillColor(field) {
      let color = '';
      const issueId = this.damage[field];
      switch (issueId) {
        case issueType.NONE.id:
          color = issueType.NONE.color;
          break;
        case issueType.DAMAGED.id:
          color = issueType.DAMAGED.color;
          break;
        case issueType.SCRATCHED.id:
          color = issueType.SCRATCHED.color;
          break;
        case issueType.PAINTED.id:
          color = issueType.PAINTED.color;
          break;
        case issueType.REPLACED.id:
          color = issueType.REPLACED.color;
          break;
        case issueType.LOCALLY_PAINTED.id:
          color = issueType.LOCALLY_PAINTED.color;
          break;
        default:
          color = 'default';
          break;
      }
      return `${color}--fill`;
    },
    issueIconColor(issue) {
      return `${issue.color}--text `;
    },
    checkPlate($event) {
      // const char = String.fromCharCode($event.keyCode);
      if (/[^A-Za-z0-9\b]+/g.test($event.data)) {
        $event.preventDefault();
        return false;
      }
      return true;
    },
    checkChassisNumber($event) {
      // const char = String.fromCharCode($event.keyCode);
      if (/[^A-Za-z0-9\b]+/g.test($event.data)) {
        $event.preventDefault();
        return false;
      }
      return true;
    },
    continueProcess() {
      this.$v.$touch();
      if (this.$v.damage.$invalid) {
        return;
      }

      this.loading = true;
      this.saveCarDamage(this.damage)
        .then(() => {
          this.$router.replace({ name: 'wizardContact' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    returnBack() {
      this.changeWizardStep(this.wizardStep.CAR_INFO);
      this.$router.push({ name: 'wizardInfo' });
    },
    additionalDamageCostChanged() {
      this.damage.additionalDamageCost = null;
    },
  },
  watch: {
    'damage.plateNumber': {
      handler(newValue) {
        this.damage.plateNumber = newValue?.toUpperCase();
      },
    },
    'damage.chassisNumber': {
      handler(newValue) {
        this.damage.chassisNumber = newValue?.toUpperCase();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
svg {
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}
:deep() {
  .plate {
    input {
      text-transform: uppercase !important;
    }
  }
}

.green {
  &--fill {
    fill: #0ccc36 !important;
  }
}
.indigo {
  &--fill {
    fill: #5c6bc0 !important;
  }
}
.red {
  &--fill {
    fill: #ff0000 !important;
  }
}
.orange {
  &--fill {
    fill: #ff6600 !important;
  }
}
.grey {
  &--fill {
    fill: #696969 !important;
  }
}
.default {
  &--fill {
    fill: #e3e3e3 !important;
  }
}
</style>
